export type CmsButtonTarget = '_self' | '_blank';

type CmsButtonWithTarget = {
  target?: unknown;
  Target?: unknown;
};

function isCmsButtonWithTarget(value: unknown): value is CmsButtonWithTarget {
  return typeof value === 'object' && value !== null;
}

export function getCmsButtonTarget(button: unknown): CmsButtonTarget | undefined {
  if (!isCmsButtonWithTarget(button)) return undefined;

  const target = button.target ?? button.Target;
  return target === '_blank' || target === '_self' ? target : undefined;
}

export function getCmsButtonLinkProps(
  button: unknown,
  fallbackTarget?: CmsButtonTarget,
): { target?: CmsButtonTarget; rel?: string } {
  const target = getCmsButtonTarget(button) ?? fallbackTarget;

  return target === '_blank' ? { target, rel: 'noopener noreferrer' } : target ? { target } : {};
}
